const TIPO_CONFIG = {
  live:       { label: 'Live',        cor: 'var(--lavender)' },
  aula:       { label: 'Aula',        cor: 'var(--teal)'     },
  lancamento: { label: 'Lançamento',  cor: 'var(--blush)'    },
};

function parseData(str) {
  if (!str) return new Date('invalid');
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    const [d, m, y] = str.split('/');
    return new Date(`${y}-${m}-${d}T00:00:00`);
  }
  return new Date(str + 'T00:00:00');
}

export default function AgendaDoMes({ eventos }) {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const mesAtual  = hoje.getMonth();
  const anoAtual  = hoje.getFullYear();

  const eventosFiltrados = (eventos || [])
    .map(e => ({ ...e, _data: parseData(e.data) }))
    .filter(e => {
      return (
        e._data >= hoje &&
        e._data.getMonth() === mesAtual &&
        e._data.getFullYear() === anoAtual
      );
    })
    .sort((a, b) => a._data - b._data);

  // Fica oculto automaticamente se não houver eventos futuros
  if (eventosFiltrados.length === 0) return null;

  const nomeMes = hoje.toLocaleDateString('pt-BR', { month: 'long' });

  return (
    <div className="section">
      <div className="secao-header">
        <h2 className="section-title">Agenda do mês</h2>
        <p className="section-subtitle" style={{ textTransform: 'capitalize' }}>
          {nomeMes}
        </p>
      </div>

      <div className="agenda-lista">
        {eventosFiltrados.map(e => {
          const dia = e._data.getDate();
          const mes = e._data.toLocaleDateString('pt-BR', { month: 'short' })
            .replace('.', '');
          const tipo = TIPO_CONFIG[e.tipo] || { label: e.tipo, cor: 'var(--navy)' };

          return (
            <div key={e.id} className="agenda-item">
              {/* Badge de data */}
              <div className="agenda-data">
                <span className="agenda-dia">{dia}</span>
                <span className="agenda-mes">{mes}</span>
              </div>

              {/* Info */}
              <div className="agenda-info">
                <span
                  className="agenda-tipo-badge"
                  style={{ background: tipo.cor }}
                >
                  {tipo.label}
                </span>
                <p className="agenda-titulo">{e.titulo}</p>
              </div>

              {/* Link opcional */}
              {e.link && (
                <a
                  href={e.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="agenda-link"
                  aria-label="Ver evento"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
